import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserAdmin } from 'app/shared/models/class/user/user';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAdminService {

  private api_url = environment.apiUrl + '/AdminUser';

  constructor(private http: HttpClient) { }

  getByRole(role: string): Observable<UserAdmin[]> {
    if (role === 'admin') {
      return this.http.get<UserAdmin[]>(`${this.api_url}/all`);
    } else {
      return this.http.get<UserAdmin[]>(`${this.api_url}/all?roles=${role}`);
    }
  }

  getByKey(key: number): Observable<UserAdmin> {
    return this.http.get<UserAdmin>(`${this.api_url}/${key}`);
  }

  post(user: UserAdmin): Observable<UserAdmin> {
    return this.http.post<UserAdmin>(this.api_url, user);
  }

  put(user: UserAdmin): Observable<UserAdmin> {
    return this.http.put<UserAdmin>(this.api_url, user);
  }

  resetPassword(key: number): Observable<any> {
    return this.http.post(`${this.api_url}/InitPassword?userKey=${key}`, {});
  }

  delete(key: number): Observable<any> {
    return this.http.delete(`${this.api_url}/${key}`);
  }

  // Roles
  getRoles(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/Role/all`);
  }

}
